// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartLinesListHeaderStyles } from "@rpsc/Overrides/Components/CartLinesListHeader";
import IconPencilEdit from "@rpsc/XDL/Icons/IconPencilEdit";
import { color, createLinkIconStyles, xScreen } from "@rpsc/XDL/Utilities";
import { mergeWithCss } from "@rpsc/XDL/Utilities/mergeWithCss";
import { css } from "styled-components";

cartLinesListHeaderStyles.wrapper = {
    ...mergeWithCss(cartLinesListHeaderStyles.wrapper, {
        css: css`
            border-bottom: none;
            border-top: 1px solid ${color("common.border")};
            padding: 24px 0 16px;
            align-items: center;
            ${xScreen("lte", "md")} {
                border-bottom: none;
                align-items: end;
            }
        `,
    }),
};

cartLinesListHeaderStyles.titleContainer = {
    css: css`
        display: flex;
        gap: 24px;
        align-items: center;
        ${xScreen("lte", "md")} {
            flex-direction: column;
            align-items: start;
            gap: 16px;
        }
    `,
};

cartLinesListHeaderStyles.productCountText = {
    variant: "h3",
    css: css`
        margin: 0;
    `,
};

cartLinesListHeaderStyles.editLink = {
    ...createLinkIconStyles(IconPencilEdit),
};
